import {
  Menu as MenuIcon,
  Logo,
} from '../icons';
import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  Container
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

const LandingNavBar = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileMenuAnchor, setMobileMenuAnchor] = useState(null);

  const handleMobileMenuOpen = (event) => {
    setMobileMenuAnchor(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuAnchor(null);
  };

  const handleNavigation = (path) => {
    navigate(path);
    handleMobileMenuClose();
  };

  const navigationItems = [
    { label: 'How It Works', action: () => {
      // Scroll to features section on landing page
      const element = document.getElementById('features-section');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
      handleMobileMenuClose();
    }},
    { label: 'For Restaurants', action: () => {
      // Scroll to restaurant section on landing page
      const element = document.getElementById('restaurant-section');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
      handleMobileMenuClose();
    }},
    { label: 'Sign In', action: () => handleNavigation('/login') },
    { label: 'Register Restaurant', action: () => handleNavigation('/register'), variant: 'contained' }
  ];

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        color: theme.palette.text.primary,
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        borderBottom: '1px solid rgba(0,0,0,0.1)',
      }}
    >
      <Container maxWidth="lg" sx={{ px: 2 }}>
        <Toolbar sx={{ justifyContent: 'space-between', py: 1 }}>
          {/* Logo/Brand */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              '&:hover': {
                opacity: 0.8,
              },
              transition: 'opacity 0.2s ease',
            }}
            onClick={() => navigate('/')}
          >
            <Logo size={32} style={{ marginRight: 12 }} />
            <Typography
              variant="h5"
              component="div"
              sx={{
                fontWeight: 'bold',
                color: theme.palette.primary.main,
                letterSpacing: '-0.025em',
              }}
            >
              merchqry
            </Typography>
          </Box>

          {/* Desktop Navigation */}
          {!isMobile && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {navigationItems.map((item, index) => (
                <Button
                  key={index}
                  variant={item.variant || 'text'}
                  color={item.variant === 'contained' ? 'primary' : 'inherit'}
                  onClick={item.action}
                  sx={{
                    px: 2,
                    py: 1,
                    borderRadius: '8px',
                    fontWeight: 500,
                    transition: 'all 0.2s ease',
                    color: item.variant === 'contained' ? 'white' : theme.palette.text.primary,
                    backgroundColor: item.variant === 'contained' ? theme.palette.primary.main : 'transparent',
                    '&:hover': {
                      backgroundColor: item.variant === 'contained'
                        ? theme.palette.primary.dark
                        : 'rgba(0,0,0,0.04)',
                      transform: 'translateY(-1px)',
                      boxShadow: item.variant === 'contained' ? '0 4px 15px rgba(0,0,0,0.2)' : 'none',
                    },
                  }}
                >
                  {item.label}
                </Button>
              ))}
            </Box>
          )}

          {/* Mobile Menu Button */}
          {isMobile && (
            <IconButton
              edge="end"
              color="inherit"
              aria-label="menu"
              onClick={handleMobileMenuOpen}
              sx={{
                color: theme.palette.text.primary,
                '&:hover': {
                  color: theme.palette.primary.main,
                  backgroundColor: 'rgba(0,0,0,0.04)',
                },
                p: 1,
              }}
            >
              <MenuIcon />
            </IconButton>
          )}

          {/* Mobile Menu */}
          <Menu
            anchorEl={mobileMenuAnchor}
            open={Boolean(mobileMenuAnchor)}
            onClose={handleMobileMenuClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            PaperProps={{
              sx: {
                borderRadius: '12px',
                boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
                border: '1px solid rgba(0,0,0,0.1)',
                mt: 1,
                minWidth: 180,
              },
            }}
          >
            {navigationItems.map((item, index) => (
              <MenuItem
                key={index}
                onClick={item.action}
                sx={{
                  px: 2,
                  py: 1.5,
                  fontWeight: item.variant === 'contained' ? 600 : 400,
                  color: item.variant === 'contained' ? theme.palette.primary.main : 'inherit',
                  backgroundColor: item.variant === 'contained' ? 'rgba(25, 118, 210, 0.08)' : 'transparent',
                  '&:hover': {
                    color: theme.palette.primary.main,
                    backgroundColor: 'rgba(25, 118, 210, 0.04)',
                  },
                  transition: 'all 0.2s ease',
                }}
              >
                {item.label}
              </MenuItem>
            ))}
          </Menu>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default LandingNavBar;
